/* =========================================================================
   Cart-Seite: Upsell-Liste nach Warenkorb-Aenderung neu laden.
   PERF Phase 3 (A/B-Rueckbau): window.getNewUpsellItems lag frueher in
   assets/precard.js (PreCart-Popup, Variante A des beendeten A/B-Tests)
   und wurde auf JEDER Seite geladen. Einziger Konsument ist
   assets/cart-dawn.js:368 auf der Cart-Seite — die Funktion lebt jetzt
   hier und laedt nur noch mit der Cart-Seite (sections/main-cart-items).
   Logik 1:1 aus precard.js uebernommen, nur mit Guards abgesichert.
   ========================================================================= */
(function () {
  'use strict';

  window.getNewUpsellItems = async function () {
    try {
      var res = await fetch('/cart', {
        method: 'GET',
        headers: { 'Content-Type': 'text/html' }
      });
      if (!res.ok) throw new Error('HTTP error! status: ' + res.status);
      var html = await res.text();
      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.cart-page__products-w');

      if (fresh) {
        var current = document.querySelector('.cart-page__products-w');
        if (current) {
          current.innerHTML = fresh.innerHTML;
          if (typeof window.initCartUpsellSwiper === 'function') {
            window.initCartUpsellSwiper();
          }
          // quick-add.js neu ausfuehren, damit die frisch eingesetzten
          // Upsell-Karten ihre Click-Handler bekommen (Verhalten wie zuvor).
          document.querySelectorAll('script').forEach(function (s) {
            if (s.src && s.src.indexOf('quick-add.js') > -1) {
              var src = s.src;
              s.remove();
              var ns = document.createElement('script');
              ns.src = src;
              document.body.appendChild(ns);
            }
          });
          if (typeof window.secondaryUpsellsLogic === 'function') {
            window.secondaryUpsellsLogic();
          }
          document.body.classList.remove('hide-upsells-cart');
        }
      } else {
        document.body.classList.add('hide-upsells-cart');
      }
    } catch (e) {
      console.error('Error:', e);
    }
  };
})();
